import { render, staticRenderFns } from "./locationTable.vue?vue&type=template&id=18255e83&"
import script from "./locationTable.vue?vue&type=script&lang=js&"
export * from "./locationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports